<template>
  <transition name="fade-in" appear>
    <div
      v-hover-scale-mouse
      data-apollo-hover
      class="copyright"
      :class="{ 'copyright--menu-open': menuIsOpen }"
      @click="toggleFooter">
        <info-icon
          class="info-icon"
          :class="{ 'info-icon--color-pink': footerIsOpen }"/>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import InfoIcon from '@/assets/svg/info.svg';

export default {
  name: 'AppCopyright',
  components: {
    InfoIcon,
  },
  computed: {
    ...mapState([
      'menuIsOpen',
      'footerIsOpen',
    ]),
  },
  methods: {
    ...mapMutations(['toggleFooter']),
  },
};
</script>

<style scoped lang="scss">
.copyright {
  line-height: 0;
  visibility: hidden;
  opacity: 0;
  width: 1.8vw;
  min-width: 27px;

  cursor: pointer;

  z-index: 20;

  transform: translateY(50%);
  transform-origin: 50% 100%;

  transition: transform .6s cubic-bezier(0.215, 0.61, 0.355, 1),
              opacity 2s 2s cubic-bezier(0.165, 0.84, 0.44, 1);

  @include mq(mobileL) {
    visibility: visible;
    opacity: 1;
  }

  &:hover {
    transform-origin: 50% 100%;
    transform: scale(1.3) translateY(50%);
  }

  &--menu-open {
    visibility: visible;
    opacity: 1;
  }
}

.info-icon {
  ::v-deep path {
    transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  ::v-deep .circle {
    fill: white;
    stroke: white;
  }
  ::v-deep .letter {
    stroke: white;
  }

  &--color-pink {
    ::v-deep .circle {
      fill: $color-accent;
      stroke: $color-accent;
    }
    ::v-deep .letter {
      stroke: $color-accent;
    }
  }
}

/* animation */
.fade-in {
  &-enter-active {
    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter {
    opacity: 0;
  }
}
</style>
